import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-grid",
  "use": "icon-grid-usage",
  "viewBox": "0 0 16 16",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" fill=\"none\" viewBox=\"0 0 16 16\" id=\"icon-grid\">\n    <path fill=\"currentColor\" d=\"M0 0H4V4H0zM0 6H4V10H0zM0 12H4V16H0zM6 0H10V4H6zM6 6H10V10H6zM6 12H10V16H6zM12 0H16V4H12zM12 6H16V10H12zM12 12H16V16H12z\" />\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol